import request from "./api";
import qs from "qs";

export function getObj(data) {
  return request({
    url: "/analy/analyreportsubject/examquestionanswer",
    method: "get",
    params: data,
  });
}
export function examquestionanswerV2(data) {
  return request({
    url: "/analy/analyreportsubject/examquestionanswer/v2",
    method: "get",
    params: data,
  });
}

export function generateAiAnswer(data) {
  return request({
    url: "/analy/analyreport/generateaianswer",
    method: "post",
    data: data,
  });
}

export function getGradelist(data) {
  return request({
    url: "/cms/schoolgradeclass/gradelist",
    method: "get",
    params: data,
  });
}

export function getAppVersion(data) {
  return request({
    url: "/qa/usercenter/getAppVersion",
    method: "get",
    params: data,
  });
}

export function knowledgePage(data) {
  let query = {
    size: data.size,
    current: data.current,
  };
  let str = qs.stringify(query);
  return request({
    url: "/analy/analystatgrade/knowledge/page?" + str,
    method: "post",
    data: data,
  });
}

export function knowledgeInfo(data) {
  return request({
    url: "/analy/analystatgrade/knowledge/info",
    method: "post",
    data: data,
  });
}

export function getexampaperimgzip(data) {
  return request({
    url: "/resource/exampaperrelation/getexampaperimgzip/" + data.id,
    method: "get",
    params: data,
  });
}

export function questionInfo(data) {
  return request({
    url: "/analy/analystatgrade/question/info",
    method: "post",
    data: data,
  });
}

export function examquestion(id) {
  return request({
    url: "/resource/examquestion/" + id,
    method: "get",
  });
}

export function questionPage(data) {
  return request({
    url: "/analy/analystatgrade/question/page",
    method: "post",
    data: data,
  });
}

export function questionCorrect(data) {
  let tokenData = {
    token: data.token,
    schoolID: data.schoolID,
  };
  delete data.token;
  delete data.schoolID;
  let qsdata = qs.stringify(data);
  return request({
    url: "/analy/analystatgrade/question/correct?" + qsdata,
    method: "post",
    data: tokenData,
  });
}

export function masterinfo(data) {
  return request({
    url: "/analy/analystatgrade/knowledge/masterinfo",
    method: "post",
    data: data,
  });
}

export function paperlistinfo(data) {
  return request({
    url: "/analy/analystatgrade/knowledge/paperlistinfo",
    method: "post",
    data: data,
  });
}

export function classlistbygrade(data) {
  return request({
    url: "/cms/schoolgradeclass/classlistbygrade",
    method: "get",
    params: data,
  });
}

export function getquestionanswer(data) {
  return request({
    url: "/qa/hwanswerstudentnew/getquestionanswer",
    method: "get",
    params: data,
  });
}

export function getcorrectdetails(data) {
  return request({
    url: "/qa/hwcontentnew/getdetailsforweb",
    method: "get",
    params: data,
  });
}

export function querypage(data) {
  return request({
    url: "/cms/schoolstudent/querypage",
    method: "post",
    data: data,
  });
}

export function questionnaireAnswer(data) {
  return request({
    url: "/qa/questionnaire/answer",
    method: "post",
    data: data,
  });
}

export function getExamList(data) {
  return request({
    url: "/resource/exampaperplan/get/examList",
    method: "post",
    data: data,
  });
}

export function systemPage(data) {
  return request({
    url: "/resource/exampaperrelation/system/page",
    method: "post",
    data: data,
  });
}

export function gradetypecount(data) {
  return request({
    url: "/resource/exampaperrelation/system/gradetypecount",
    method: "post",
    data: data,
  });
}

export function studentsummary(data) {
  return request({
    url: "/analy/analystatgrade/knowledge/studentsummary",
    method: "get",
    params: data,
  });
}

export function getexampaperinfo(data) {
  return request({
    url: "/resource/exampaperrelation/getexampaperinfo/" + data.id,
    method: "get",
    params: data,
  });
}

export function updateexampapercountview(data) {
  return request({
    url: "/resource/exampaperrelation/updateexampapercountview/" + data.id,
    method: "get",
    params: data,
  });
}

export function getQuestion(data) {
  return request({
    url: "/qa/questionnaire/getQuestion",
    method: "get",
    params: data,
  });
}

export function subjectlistbygrade(data) {
  return request({
    url: "/cms/schoolgradeclass/subjectlistbygrade",
    method: "get",
    params: data,
  });
}

export function subjectlistbygradeandclassnum(data) {
  return request({
    url: "/cms/schoolgradeclass/subjectlistbygradeandclassnum",
    method: "get",
    params: data,
  });
}

export function traininglist(data) {
  return request({
    url:
      "/exam/exampaperquestion/traininglist/" +
      data.examPaperId +
      "/" +
      data.questionId,
    method: "get",
    params: data,
  });
}
